export default {
	title: "",
	subtitle: "Example 2: Pay-Out - USD to BRL",
  path: "example_transaction_payout",
	paragraphs: ["The following example simulates a pay-out transaction where the partner sends 500 USD to a FacilitaPay’s international bank account, and the amount is later converted to BRL and transferred to the customer’s bank account in Brazil."],
  image: {
		path: "/static/diagrams/payoutTransaction.png",
		description: "Pay-out webhooks flow"
	},
	request: {
		payload: {
			"transaction": {
				"currency": "USD",
				"exchange_currency": "BRL",
				"value": "500.00",
				"from_bank_account_id": "a2474d90-eca9-47ac-90f2-0487d51b4bef",
        		"to_bank_account_id": "c41b7cf3-455c-46c1-bb6d-7fd0e1b83799",
        		"subject_id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21"
			}
		},
		responses: {
			"data": {
				"value": "500.00",
				"to_bank_account": {
					"routing_number": null,
					"pix_info": {
						"type": "CNPJ",
						"key": "00.623.904/0001-73"
					},
					"owner_name": null,
					"owner_document_type": "cpf",
					"owner_document_number": null,
					"nickname": null,
					"intermediary_bank_account_id": null,
					"id": "c41b7cf3-455c-46c1-bb6d-7fd0e1b83799",
					"iban": null,
					"currency": "BRL",
					"branch_number": null,
					"branch_country": "BRA",
					"bank": {
						"swift": "BCBPIXCNPJ000",
						"name": "PIX Key - CNPJ",
						"ispb": null,
						"id": "aa3bfacc-dd6b-4a68-b37a-7672b43b1c52",
						"country": "BRA",
						"code": null
					},
					"account_type": "conta-corrente",
					"account_number": null,
					"aba": null
				},
				"subject_is_receiver": true,
				"subject_id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21",
				"subject": {
					"updated_at": "2021-04-29T22:15:10.988964",
					"status": "approved",
					"social_name": "John Doe",
					"required_clearance_level": 1,
					"references": [],
					"phone_number": null,
					"net_monthly_average_income": "15000.00",
					"inserted_at": "2021-03-08T19:56:22.628081",
					"id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21",
					"fiscal_country": "Brasil",
					"email": null,
					"document_type": "cpf",
					"document_number": "05069869183",
					"clearance_level": 1,
					"birth_date": "1965-04-06",
					"address_street": "Rua Barão do Rio Branco",
					"address_state": "SP",
					"address_postal_code": "16201220",
					"address_number": "2252",
					"address_country": "BR",
					"address_complement": "Apt 101",
					"address_city": "Washington"
				},
				"status": "wired",
				"source_name": "John Doe",
				"source_document_type": "cpf",
				"source_document_number": "05069869183",
				"inserted_at": "2021-04-29T22:21:38.938318",
				"id": "6da07cf4-1ea2-4c92-bb0d-b690b067dad6",
				"from_credit_card": null,
				"from_bank_account": {
					"routing_number": null,
					"pix_info": null,
					"owner_name": "FACILITA PAY",
					"owner_document_type": null,
					"owner_document_number": "N/A",
					"nickname": null,
					"intermediary_bank_account_id": null,
					"id": "a2474d90-eca9-47ac-90f2-0487d51b4bef",
					"iban": null,
					"currency": "USD",
					"branch_number": null,
					"branch_country": null,
					"bank": {
						"swift": "swift-facilitapay-test",
						"name": "Test Bank",
						"ispb": null,
						"id": "9e56957c-47d9-4762-a544-eed567bf1a71",
						"country": null,
						"code": null
					},
					"account_type": "conta-corrente",
					"account_number": "1017",
					"aba": null
				},
				"for_exchange": true,
				"exchanged_value": "2688.08",
				"exchange_under_request": false,
				"exchange_currency": "BRL",
				"estimated_value_until_exchange": false,
				"currency": "USD",
				"cleared": true,
				"bank_transaction": {
					"wire_id": null,
					"value": "500",
					"spei_reference": null,
					"spei_concepto_de_pago": null,
					"source_type": "WIRE",
					"source_name": "John Doe",
					"source_id": null,
					"source_document_type": "cpf",
					"source_document_number": "05069869183",
					"source_description": "CREDITO POR TED",
					"source_branch": "1142",
					"source_bank_ispb": null,
					"source_bank": "033",
					"source_account": "130013844",
					"movement_date": "2025-07-09",
					"iof_value": "11.22",
					"inserted_at": "2025-07-09T18:38:25.219175",
					"id": "e7e08097-75ae-4ee5-b55d-1c970b8b4109",
					"exchanged_value": "2912.36",
					"exchange_rate_spot": "5.906",
					"exchange_rate": "5.82472",
					"exchange_id": "68df160f-ff84-4f3b-b26b-e8535fe65048",
					"exchange_currency": "BRL",
					"exchange_approved": true,
					"currency": "USD"
				}
			}
		}
	},
	parameterPayload: [
	{
      name: "transaction",
      type: "object",
      required: true,
      description: "transaction data containing at least the following required values:"
    },
    {
      name: "transaction.currency",
      type: "string",
      required: true,
      description: "currency of the amount to be sent to FacilitaPay or deducted from an internal bank account balance (ISO 4217 format)"
    },
    {
      name: "transaction.value",
      type: "string",
      required: true,
      description: "Amount to be sent to FacilitaPay (PIX / TED / WIRE) or deducted from an internal bank account balance"
    },
    {
      name: "transaction.exchange_currency",
      type: "string",
      required: true,
      description: "The \"destination\" currency also in (ISO 4217 format). When currency and exchange_currency are the same, no conversion will be performed and the destination would be an internal bank account"
    },
	{
		name: "transaction.from_bank_account_id",
		type: "string",
		required: true,
		description: "In this example is the ID of a Foreign Bank Account from FacilitaPay"
	},
	{
		name: "transaction.to_bank_account_id",
		type: "string",
		required: true,
		description: "In this example is the ID of your bank account in Brazil, Mexico, Colombia or Chile. You can also use your end customer's account here if making a final payment."
	},
	{
		name: "transaction.subject_id",
		type: "string",
		required: true,
		description: "The ID of the person or company involved in the transaction."
	}],
	footerNotes: 'Note that all IDs must be related, i.e.: the provided subject_id must have a bank account linked to his registration.',
	troubleshooting: {
		title: 'Common Mistakes',
		messages: [{
		code: {
			"from_bank_account_id": ["account currency does not match transaction currency"]
		},
		solution: 'Provide accounts with matching currencies as in the request.'
		}]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionPayOutExemple.js